import '../scss/frontend.scss';
import { initAppHeight, observeVisibility } from './parts/helpers';
import { fadeOutPreloader, initScrollHeader } from './parts/general';
import initSvgDrawAnimation from './parts/svgAnimations';
import setupHeaderBehavior from './parts/header';
import initPopups from './parts/popup';
import initMiniCart from './parts/mini-cart';
const onReady = () => {
    setupHeaderBehavior();
    initAppHeight();
    initScrollHeader();
    initSvgDrawAnimation();
    initPopups();
    initMiniCart();
};
const onLoad = () => {
    document.body.classList.add('loaded');
    fadeOutPreloader();
    observeVisibility('section');
    observeVisibility('.animate__fadeIn, .animate__fadeInUp, .animate__fadeInDown, .animate__fadeInLeft, .animate__fadeInRight', 'animate__animated', 0.3, false);
    document.querySelector('.js-open-accessibility')
        ?.addEventListener('click', (e) => {
        e.preventDefault();
        window.UserWay?.widgetOpen();
    });
};
document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || !target.classList.contains('qty')) {
        return;
    }
    const button = document.querySelector('[name="update_cart"]');
    if (button) {
        button.disabled = false;
        button.click();
        return;
    }
});
document.addEventListener('DOMContentLoaded', onReady);
window.addEventListener('load', onLoad);
